// Alleen het laatste antwoord telt (polish w4 ronde 1, review visual-ux-a11y "agenda Maand"): bij
// snel wisselen (weekpijlen, Dag → Maand, een SSE-poke tijdens het laden) kan een ouder verzoek
// later binnenkomen dan een nieuwer. Zonder poort overschreef dat oude antwoord de nieuwe data.

export interface LatestGate {
  /**
   * Draait `fn`; alleen als er intussen geen nieuwere aanroep is gestart, gaat de uitkomst naar
   * `onValue` of `onError`. Geeft terug of deze aanroep de laatste was.
   */
  run<T>(
    fn: () => Promise<T>,
    onValue: (value: T) => void,
    onError: (error: unknown) => void,
  ): Promise<boolean>;
}

export function createLatestGate(): LatestGate {
  let seq = 0;
  return {
    async run(fn, onValue, onError) {
      seq += 1;
      const mine = seq;
      try {
        const value = await fn();
        if (mine !== seq) return false;
        onValue(value);
        return true;
      } catch (e) {
        if (mine !== seq) return false;
        onError(e);
        return true;
      }
    },
  };
}
